import { casaApiUrl } from "configs/casa-api";

import { fetch } from "../utils/fetch";

function getCustomerGiftVouchers(customerMobile) {
  return fetch(
    `${casaApiUrl}/users/gift-vouchers-raw/customer-mobile/${customerMobile}`,
    {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    }
  ).then((response) => {
    if (response.status === 200) {
      return response.json();
    } else {
      return Promise.reject("gift voucher fetch failed");
    }
  });
}

function getCustomerGiftVouchersInCurrentStore(store, customerMobile) {
  return fetch(
    `${casaApiUrl}/users/gift-vouchers-raw/store/${store}/customer-mobile/${customerMobile}`,
    {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    }
  ).then((response) => {
    if (response.status === 200) {
      return response.json();
    } else {
      return Promise.reject("gift voucher fetch failed");
    }
  });
}

function getCustomerAvailableGiftVouchers(customerMobile, searchTerm = "") {
  const params = new URLSearchParams();
  params.append("customerOfferStatus", "ready");
  if (searchTerm) {
    params.append("searchTerm", searchTerm);
  }
  // params.append("fetchAlias", fetchAlias);
  return fetch(`${casaApiUrl}/users/gift-vouchers/customer/${customerMobile}?${params.toString()}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((response) => {
    if (response.status === 200) {
      return response.json();
    } else {
      return Promise.reject("gift voucher fetch failed");
    }
  });
}

function getGiftVoucherDetails(businessUnitId, body) {
  return fetch(
    `${casaApiUrl}/users/gift-vouchers/businessUnit/${businessUnitId}/giftVoucherDetails`,
    {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      return Promise.reject("error in fetching gift voucher details");
    });
}

function applyVoucher(businessUnitId, body) {
  return fetch(
    `${casaApiUrl}/users/gift-vouchers/businessUnit/${businessUnitId}/activateGiftVoucher`,
    {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      return Promise.reject("error in gift voucher activation");
    });
}

export default {
  getCustomerGiftVouchers,
  getCustomerGiftVouchersInCurrentStore,
  getCustomerAvailableGiftVouchers,
  getGiftVoucherDetails,
  applyVoucher,
};




// WEBPACK FOOTER //
// ./src/services/gift-voucher-service.js